import { getDraft, clearDraft } from '~/lib/utils/autosave';
import ToggleRepliesWidget from '/builds/gitlab/gitlab-ee/app/assets/javascripts/notes/components/toggle_replies_widget.vue?vue3';
import { getAutosaveKey, getIdFromGid } from '../utils';
import WikiNote from '/builds/gitlab/gitlab-ee/app/assets/javascripts/wikis/wiki_notes/components/wiki_note.vue?vue3';
import WikiDiscussionsSignedOut from '/builds/gitlab/gitlab-ee/app/assets/javascripts/wikis/wiki_notes/components/wiki_discussions_signed_out.vue?vue3';
import WikiCommentForm from '/builds/gitlab/gitlab-ee/app/assets/javascripts/wikis/wiki_notes/components/wiki_comment_form.vue?vue3';
import PlaceholderNote from '/builds/gitlab/gitlab-ee/app/assets/javascripts/wikis/wiki_notes/components/placeholder_note.vue?vue3';
import DiscussionActions from '/builds/gitlab/gitlab-ee/app/assets/javascripts/wikis/wiki_notes/components/discussion_actions.vue?vue3';
export default {
    name: 'WikiDiscussion',
    components: {
        WikiNote,
        PlaceholderNote,
        WikiCommentForm,
        WikiDiscussionsSignedOut,
        ToggleRepliesWidget,
        DiscussionActions
    },
    inject: [
        'noteableType',
        'currentUserData'
    ],
    props: {
        discussion: {
            type: Object,
            required: true
        },
        noteableId: {
            type: String,
            required: true
        }
    },
    emits: [
        'note-deleted'
    ],
    data () {
        return {
            isReplying: false,
            replies: [],
            firstNote: {},
            placeholderNote: {},
            collapsed: this.discussion.resolved
        };
    },
    computed: {
        notes () {
            return this.discussion.notes.nodes;
        },
        resolved () {
            return this.discussion.resolved;
        },
        canReply () {
            return this.userSignedId && this.getUserPermissions(this.firstNote).createNote;
        },
        renderReplyPlaceHolder () {
            return this.canReply && !this.isReplying;
        },
        renderCommentForm () {
            return this.isReplying && this.canReply;
        },
        userSignedId () {
            return Boolean(this.currentUserData?.id);
        },
        noteId () {
            return getIdFromGid(this.firstNote.id);
        },
        discussionId () {
            return getIdFromGid(this.firstNote.discussion?.id);
        },
        autosaveKey () {
            return getAutosaveKey(this.noteableType, this.discussionId);
        },
        canResolve () {
            return this.discussion.resolvable && this.firstNote.userPermissions?.resolveNote;
        }
    },
    watch: {
        notes: {
            immediate: true,
            handler () {
                this.populateReplies();
            }
        },
        discussion: {
            deep: true,
            handler (after, before) {
                if (before?.resolved !== after?.resolved && // only collapse if the user didn't add a new comment
                before.notes.nodes.length === after.notes.nodes.length) {
                    this.collapsed = Boolean(after?.resolved);
                }
            }
        }
    },
    mounted () {
        if (getDraft(this.autosaveKey)?.trim()) {
            this.isReplying = true;
        }
    },
    methods: {
        populateReplies () {
            const notesCopy = [
                ...this.notes
            ];
            this.firstNote = notesCopy.shift() || {};
            this.replies = notesCopy;
        },
        setPlaceHolderNote (note) {
            this.placeholderNote = note;
        },
        toggleReplying (value) {
            this.isReplying = value;
            if (!this.isReplying) clearDraft(this.autosaveKey);
        },
        updateNote () {
            this.placeholderNote = {};
            this.toggleReplying(false);
        },
        getUserPermissions (note) {
            return JSON.parse(JSON.stringify(note.userPermissions || {}));
        },
        toggleCollapsed () {
            this.collapsed = !this.collapsed;
        }
    }
};
